import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

// occurredAt is the caller's timestamp, not one taken here -- every call site awaits a delete
// request (and some also await a confirmation modal) before building this entry, so a timestamp
// taken here would report when the round trip finished, not when the customer actually acted.
type ItemDeletedSourcePath =
  | 'trip_planner.itinerary.canvas.delete_highlight'
  | 'trip_planner.itinerary.day_canvas.delete_item'
  | 'trip_planner.itinerary.canvas.flight_delete'
  | 'trip_planner.itinerary.canvas.cruise_delete'
  | 'trip_planner.cart.delete_item'
  | 'trip_planner.list.delete_row'
  | 'trip_planner.add_hotel_modal.remove_item'

export function buildItemDeletedActivityEntry(itemName: string, sourcePath: ItemDeletedSourcePath, occurredAt: string, outcome?: { deletedItemIds: ReadonlyArray<number>, requestedCount: number }): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'item_deleted',
    label: 'Deleted itinerary item',
    displayText: boundActivityDisplayText(outcome && outcome.deletedItemIds.length < outcome.requestedCount
      ? `Removed ${outcome.deletedItemIds.length} of ${outcome.requestedCount} items from "${itemName}"; remaining items were not removed`
      : `Removed "${itemName}" from the itinerary`),
    sourcePath,
    dataClassification: 'personalised_surface',
    occurredAt,
    fields: outcome ? [{ key: 'deletedItemIds', value: outcome.deletedItemIds.join(','), dataClassification: 'personalised_surface' }] : undefined,
  }
}
